export default __webpack_public_path__ + "static/media/cruelty-free.109cb927.svg";